import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Snackbar,
  Grid,
  MenuItem,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CashFreePayment from "../payment/CashFreePayment";
import instance from "../../Axios/axiosConfig";
import CloseIcon from "../payment/CloseIcon";
import PayPalCheckout from "../../header/PayPalCheckout";

const BuyModal = ({ open, onClose, post }) => {
  const [step, setStep] = useState(0);
  const [currency, setCurrency] = useState("INR");
  const [customSlug, setCustomSlug] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [snackMessage, setSnackMessage] = useState("");

  useEffect(() => {
    if (open) {
      setStep(0);
      setCustomSlug("");
      setPhone("");
      setName(localStorage.getItem("name") || "");
      setEmail(localStorage.getItem("email") != "null" ?  localStorage.getItem("email") : "");
    }
  }, [open]);

  const getLiveUrl = () => {
    if (!post) return "";
    return customSlug
      ? `https://justpasteit.in/publish/${customSlug}.html`
      : `https://justpasteit.in/publish/${post.uniqueId}.html`;
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(getLiveUrl());
    setSnackMessage("URL copied to clipboard!");
  };

  const isPhoneValid = () => {
    if (currency === "USD") return true;
    return /^[6-9]\d{9}$/.test(phone);
  };

  const isEmailValid = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleBuyClick = () => {
    setStep(1);
  };

  const handlePaymentSuccess = async () => {
    try {
      await instance.post(`/publish/${post.uniqueId}/mark-premium`, {
        customSlug: customSlug.trim() || null,
      });

      // 2. Save premium user details
    await instance.post("/contact/addPremium", {
        name,
        email,
        phone,
      });
      setSnackMessage("Your page is now live!");
      onClose();
    } catch (error) {
      console.error("Error marking post as premium:", error);
      setSnackMessage("Payment succeeded, but activation failed.");
    }
  };

  const renderStepIndicator = () => (
    <Box sx={{ textAlign: "center", mt: 3 }}>
      <Box sx={{ display: "inline-flex", gap: 2 }}>
        {[1, 2].map((num) => (
          <Box
            key={num}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: step + 1 === num ? "#2f80ed" : "gray",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {num}
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <>
      <Modal open={open} onClose={onClose}>
            
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: { xs: "90%", sm: "500px" },
          }}
        >
          <CloseIcon  onClick={onClose} />  
          <Typography fontWeight="bold" mb={2}>
            Get your page live now at just {currency === "INR" ? "INR 49" : "USD 1"} for lifetime!
          </Typography>

          <TextField
            label="Live URL"
            fullWidth
            margin="normal"
            value={getLiveUrl()}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={copyToClipboard}>
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Custom URL slug (optional)"
            placeholder="your-name-or-keyword"
            value={customSlug}
            onChange={(e) => setCustomSlug(e.target.value.trim())}
          />

          <TextField
            select
            fullWidth
            label="Select Currency"
            margin="normal"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            <MenuItem value="INR">INR</MenuItem>
            <MenuItem value="USD">USD</MenuItem>
          </TextField>

          {step === 0 && (
            <Box textAlign="center" mt={3}>
              <Button variant="contained" color="primary" onClick={handleBuyClick}>
                Buy
              </Button>
            </Box>
          )}

          {step === 1 && (
            <>
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    type="tel"
                    placeholder={currency === "INR" ? "9876543210" : "Optional"}
                  />
                </Grid>
              </Grid>

              <Box textAlign="center" mt={3}>
                {name && email && isEmailValid(email) && isPhoneValid() ? (
                  currency === "INR" ? (
                    <CashFreePayment
                      amount={49}
                      phoneNumber={phone}
                      onSuccess={handlePaymentSuccess}
                    />
                  ) : (
                    <PayPalCheckout Value={0.50} />
                  )
                ) : (
                  <Typography color="error" mt={1}>
                    Please fill all fields correctly.
                  </Typography>
                )}
              </Box>

              {renderStepIndicator()}
            </>
          )}
        </Box>
      </Modal>

      <Snackbar
        open={!!snackMessage}
        autoHideDuration={3000}
        onClose={() => setSnackMessage("")}
        message={snackMessage}
      />
    </>
  );
};

export default BuyModal;
